import React from "react";

const StatCard = ({
  count,
  label,
  style = {},
  countStyle = {},
  labelStyle = {},
}) => {
  return (
    <div style={{ ...baseStyles.card, ...style }}>
      <div style={{ ...baseStyles.count, ...countStyle }}>{count}</div>
      <div style={{ ...baseStyles.label, ...labelStyle }}>{label}</div>
    </div>
  );
};

const baseStyles = {
  card: {
    padding: "16px 20px",
    background: "#fff",
  },
  count: {
    fontSize: "40px",
    fontWeight: 500,
    lineHeight: 1,
    marginBottom: "8px",
    color: "#000",
  },
  label: {
    fontSize: "14px",
    color: "#6b7280", // gray text
    lineHeight: 1.4,
    fontWeight: 400,
  },
};

export default StatCard;
